import {
    BaseSubChartProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/base-sub-chart';
import {
    MarkerType,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/legend/legend.interface';
import { STRadarStyle } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import {
    getFirstThemeLineStyle,
    getThemeColorValueByIndex, getThemeStyleTransformOpt,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/theme';
import { CANVAS_PT_SCALE } from '@src/slide/infrastructure/module/independent/unit';
import type { IRadarChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/radar-chart.interface';
import type { IRadarChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';
import type {
    IChartShapeProps,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';
import type {
    ILegendMarker } from '@src/slide/domain/ui-model/element-modeles/property/chart/legend/legend.interface';
import { DataPoint, IChartSeries } from '../../../Interface/chart-v3/sub-chart/sub-chart-properties.interface';
import { IThemeModel } from '../../../Interface/theme-model.interface';

export class RadarChartProperty extends BaseSubChartProperty<IRadarChart> implements IRadarChartProperty {
    public get radarStyle() {
        return this.uiData.radarStyle;
    }

    public getLegendMarker(props: IChartShapeProps): ILegendMarker {
        const { fillBackground, border } = props.style || {};

        return {
            symbol: fillBackground ? MarkerType.Square : MarkerType.Line,
            props: {
                ...props,
                style: {
                    ...props?.style,
                    border: {
                        ...this.createBorderFillWithFillBackground(fillBackground),
                        ...border,
                    },
                },
            },
        };
    }

    public getGeometryColorPath = () => {
        if (this.isRadarFilled) {
            return 'fillBackground.solidFill.color';
        }
        return 'border.tdColor';
    };

    public getDefaultThemeStyle = (target: IChartSeries | DataPoint, index: number, colorPaletteId?: string, total?: number): IChartShapeProps['style'] => {
        const color = this.getThemeColor(index, colorPaletteId, total);

        if (this.isRadarFilled) {
            return {
                fillBackground: {
                    solidFill: {
                        // @ts-ignore
                        color,
                    },
                },
            };
        }

        const firstSerStyle = this.series?.[0]?.props?.style;
        return {
            border: {
                // @ts-ignore
                color,
                tdColor: color,
                width: firstSerStyle?.border?.width || 1.5 * CANVAS_PT_SCALE,
            },
        };
    };

    private get isRadarFilled() {
        return this.radarStyle === STRadarStyle.filled;
    }
}

